module.exports = __webpack_public_path__ + "static/media/ProximaNova-BoldIt.0e18c5b3.ttf";